<template>
  <sdCards :title="$t('pages.apps.modules.tracking.new-title')">
    <a-form layout="vertical" :model="formData" @submit="handleSubmit">
      <a-row :gutter="16">
        <a-col :span="12"
          ><a-form-item :label="$t('pages.apps.modules.tracking.type') + ':'">
            <a-select default-value="1" v-model:value="formData.location" @change="formData.block_id = '0'">
              <a-select-option value="1">
                {{ $t('pages.apps.modules.tracking.locations.before-head') }}
              </a-select-option>
              <a-select-option value="2">
                {{ $t('pages.apps.modules.tracking.locations.after-body') }}
              </a-select-option>
              <a-select-option value="3">
                {{ $t('pages.apps.modules.tracking.locations.before-body') }}
              </a-select-option>
              <a-select-option value="4">
                {{ $t('pages.apps.modules.tracking.locations.member-approve') }}
              </a-select-option>
              <a-select-option value="5">
                {{ $t('pages.apps.modules.tracking.locations.member-approve-before-head') }}
              </a-select-option>
              <a-select-option value="7"> {{ $t('pages.apps.modules.tracking.locations.amp') }} </a-select-option>
              <a-select-option value="6"> {{ $t('pages.apps.modules.tracking.locations.block') }} </a-select-option>
            </a-select>
          </a-form-item></a-col
        >
        <a-col :span="12">
          <a-form-item :label="$t('pages.apps.modules.tracking.block') + ':'">
            <a-select default-value="0" v-model:value="formData.block_id" :disabled="formData.location != 6">
              <a-select-option value="0">
                {{ $t('common.choose') }}
              </a-select-option>
              <a-select-option value="1003">
                {{ $t('pages.apps.modules.tracking.blocks.product-list') }}
              </a-select-option>
              <a-select-option value="1004">
                {{ $t('pages.apps.modules.tracking.blocks.product-detail') }}
              </a-select-option>
              <a-select-option value="1054">
                {{ $t('pages.apps.modules.tracking.blocks.cart') }}
              </a-select-option>
              <a-select-option value="100100">
                {{ $t('pages.apps.modules.tracking.blocks.address') }}
              </a-select-option>
              <a-select-option value="100101">
                {{ $t('pages.apps.modules.tracking.blocks.payment') }}
              </a-select-option>
              <a-select-option value="100102"> {{ $t('pages.apps.modules.tracking.blocks.approve') }} </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item :label="$t('pages.apps.modules.tracking.code') + ':'">
        <codeMirror :code="formData.code" @setCode="setCode" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" :loading="iconLoading" html-type="submit"> {{ $t('common.save') }} </a-button>
      </a-form-item>
    </a-form>
  </sdCards>
</template>

<script>
import codeMirror from '@/components/codeMirror/Index';
export default {
  name: 'BlankPage',
  components: {
    codeMirror,
  },
  data() {
    return {
      iconLoading: false,
      app_id: this.$route.params.id,
      type: 'trackingcode',
      formData: {
        location: '1',
        code: null,
        block_id: '0',
      },
    };
  },
  methods: {
    handleSubmit() {
      if (this.formData.location == 6 && this.formData.block_id == 0) {
        this.$message.error(this.$t('pages.apps.modules.tracking.required-block'));
        return false;
      }
      this.iconLoading = true;
      this.$appAxios
        .post(this.$endpoints.app_module_set, { id: this.app_id, formData: this.formData, type: this.type })
        .then((resp) => {
          if (resp.data.status) {
            this.$message.success(this.$t('common.success-message'));
            this.$router.push({ name: 'detail-module-tracking' });
            this.$store.dispatch('application/get', this.app_id);
          } else {
            this.$message.error(resp.data.message);
          }
          this.iconLoading = false;
        });
    },
    setCode(code) {
      this.formData.code = code;
    },
  },
  mounted() {},
};
</script>